export default __webpack_public_path__ + "static/icons/icon-divider-8c455b27dbe706792c8f4757a6ce38d7.png";